<template>
	<form class="omapi-search flex" @submit.prevent="submit">
		<input
			v-model="internalSearchTerm"
			type="search"
			class="omapi-input omapi-input__inline"
			v-bind="$attrs"
			@keydown.esc="clear"
			@search="submit"
		/>
		<core-button button-type="submit" :size="size">Search</core-button>
	</form>
</template>

<script>
export default {
	props: {
		searchTerm: {
			type: String,
			default: '',
		},
		size: {
			type: String,
			default: 'large',
		},
	},
	data() {
		return {
			internalSearchTerm: this.searchTerm,
		};
	},
	watch: {
		searchTerm(val) {
			this.internalSearchTerm = val;
		},
	},
	methods: {
		clear() {
			this.internalSearchTerm = '';
			this.submit();
		},
		submit() {
			this.$emit('searched', this.internalSearchTerm);
		},
	},
};
</script>

<style lang="scss">
.omapi-screen .omapi-subscribers-page {
	.omapi-search {
		align-items: center;
		input[type='search'] {
			flex: 1;
			margin-bottom: 0;
			height: 30px;
		}
		button[type='submit'] {
			padding: 6px 12px;
		}
	}
}
</style>
